module.exports = __webpack_public_path__ + "static/media/K_Diamonds.fcb26db6.svg";